import React, { useState, useEffect } from 'react';
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import Button from '../../components/Button/Button';

let prevPercent = 0;

const quitAndInstall = () => {
  window.ipc.send('quitAndInstall');
};

export default function UpdateProgress(props) {
  const { checkForUpdates } = props || {};
  const [progress, setProgress] = useState({});
  const { percent, bytesPerSecond } = progress || {};
  if (window.ipc) {
    useEffect(() => {
      if (typeof window.ipc.on === 'function') {
        window.ipc.on('updateDownloadProgress', (event, storedLog) => {
          const { percent: updatedPercent } = storedLog || {};
          if (updatedPercent > prevPercent) {
            // only update progress if the download is progressing
            // (we could otherwise be getting smaller percent values from an additional download stream)
            prevPercent = updatedPercent;
            setProgress(storedLog);
          }
        });
      }
      return function cleanup() {
        if (typeof window.ipc.on === 'function') {
          window.ipc.removeAllListeners('updateDownloadProgress');
        }
      };
    }, []);
  }
  return (
    <div className="update-progress-container">
      <div className="update-progress">
        {
          percent ? (
            <div className="update-progress-bar">
              <ProgressBar percentage={percent} />
              <span>{`${parseFloat(percent).toFixed(2)}%`}</span>
            </div>
          ) : null
        }
        {
          bytesPerSecond ? <span>{`${(parseFloat(bytesPerSecond) / 1024).toFixed(2)} KB/s`}</span> : null
        }
      </div>
      {
        percent ? null : <Button label="Check for Updates" onClick={checkForUpdates} />
      }
      {
        percent === 100 ? <Button label="Quit and Install" onClick={quitAndInstall} /> : null
      }
    </div>
  );
}
